import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";
import InvitationMessage, {
  InvalidInvitationMessageError,
} from "legal-entities/invitations/messages/invitation-message";
import { debounce } from "lodash";
import { useState } from "react";

const MessageField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

type MessageInputProps = {
  idPrefix?: string;
  className?: string;
  message?: InvitationMessage;
  onChange?: (message?: InvitationMessage, error?: string) => void;
};

export default function InvitationMessageInput(props: Readonly<MessageInputProps>) {
  const { idPrefix, className, message, onChange } = props;
  const [messageFieldText, setMessageFieldText] = useState<string>(message?.value ?? "");
  const [messageFieldError, setMessageFieldError] = useState<string>("");

  function handleMessageTextChanged(value: string) {
    let newMessage: InvitationMessage | undefined;
    let messageFieldError: string = "";

    try {
      newMessage = value ? new InvitationMessage(value) : undefined;
    } catch (error) {
      if (error instanceof InvalidInvitationMessageError) {
        messageFieldError = error.message;
        return;
      }
      throw error;
    } finally {
      setMessageFieldError(messageFieldError);
      onChange?.(newMessage, messageFieldError);
    }
  }

  return (
    <MessageField
      id={idPrefix ? idPrefix + "-message-input" : "message-input"}
      className={className}
      label="Message (optional)"
      fullWidth
      minRows={5}
      multiline
      onChange={(event) => {
        const value = event.target.value;
        setMessageFieldText(value);
        debounce((value: string) => handleMessageTextChanged(value), 500)(value);
      }}
      value={messageFieldText}
      error={!!messageFieldError}
      helperText={messageFieldError}
      variant="outlined"
    />
  );
}
